import React from "react";
import { Link } from "react-router-dom";

function NoIndustryOnWorkSpace(props) {

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="bg-white alert alert-danger" role="alert">
          <h4 className="alert-heading">
            No Industry found on the selected workspace!
          </h4>
          <p>
            Looks like we are unable to find an industry under the selected
            workspace for you or there is no industry associated to the selected
            workspace.
          </p>
          <hr />
          <p className="mb-0">
            If you are the admin , Please visit admin section and associate few
            industries for the selected workspace or party. Please click&nbsp;
            <Link
              style={{ cursor: "pointer" }}
              to={"admin/dashboard"}
            >
              here
            </Link>
            &nbsp;to got to admin side
          </p>
          <br />
          <p className="mb-0">
            If you are lost , Please click&nbsp;
            <Link to="/login">here</Link>&nbsp;to login back
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default NoIndustryOnWorkSpace;
